import styled from "styled-components"

export const LayoutWrapper = styled.section`
  background: ${props => props.theme.colors.primary};
`

export const LayoutMain = styled.main`
  margin: 0 auto;
  max-width: ${props => props.theme.maxWidth};
  min-height: calc(50vh - 4em);
  padding: ${props => props.theme.padding};
`
